import { render } from "./TagView.vue?vue&type=template&id=32f41d2a&scoped=true"
import script from "./TagView.vue?vue&type=script&lang=js"
export * from "./TagView.vue?vue&type=script&lang=js"

import "./TagView.vue?vue&type=style&index=0&id=32f41d2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f41d2a"]])

export default __exports__